import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEditor } from "../../hooks/EditorProvider";
import DraggableComponent from "./DraggableComponent";
import DraggableAddComponent from "./DraggableAddComponent";
const DraggableBox = ({ elementId, childs = [], itemId, itemProps, hideAdd = false, }) => {
    const { mode } = useEditor();
    const text = itemProps?.link?.label || itemProps?.text;
    if (mode === "production") {
        return (_jsxs(_Fragment, { children: [childs?.map((item) => (_jsx(DraggableComponent, { item: item, elementId: elementId, index: 0 }, item?.id))), text && childs.length === 0 && _jsx(_Fragment, { children: text })] }));
    }
    return (_jsxs(_Fragment, { children: [childs.length === 0 && !text && !hideAdd && (_jsx(DraggableAddComponent, { draggableId: itemId, elementId: elementId })), childs?.map((item, index) => (_jsx(DraggableComponent, { item: item, elementId: elementId, index: index }, item?.id))), text && childs.length === 0 && _jsx(_Fragment, { children: text })] }));
};
export default DraggableBox;
//# sourceMappingURL=DraggableBox.js.map